"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPrivateKeyFromMnemonic = exports.validateMnemonic = exports.generateMnemonic = exports.getPrivateKeyFromKeyStore = exports.generateKeyStore = exports.verifySignature = exports.generateSignature = exports.getAddressFromPrivateKey = exports.getAddressFromPublicKey = exports.generatePubKey = exports.getPublicKeyFromPrivateKey = exports.getPublicKey = exports.generateRandomArray = exports.generatePrivateKey = exports.encodeAddress = exports.checkAddress = exports.decodeAddress = void 0;

var _bech = _interopRequireDefault(require("bech32"));

var bip32 = _interopRequireWildcard(require("bip32"));

var bip39 = _interopRequireWildcard(require("bip39"));

var _cryptoBrowserify = _interopRequireDefault(require("crypto-browserify"));

var _elliptic = require("elliptic");

var _is_js = _interopRequireDefault(require("is_js"));

var _secureRandom = _interopRequireDefault(require("secure-random"));

var _tinySecp256k = _interopRequireDefault(require("tiny-secp256k1"));

var _uuid = _interopRequireDefault(require("uuid"));

var _utils = require("../utils");

// secp256k1 privkey is 32 bytes
var PRIVKEY_LEN = 32;
var MNEMONIC_LEN = 256;
var DECODED_ADDRESS_LEN = 20;
var CURVE = "secp256k1"; //hdpath

var HDPATH = "44'/714'/0'/0/";
var ec = new _elliptic.ec(CURVE);
/**
 * Decodes an address in bech32 format.
 * @category crypto
 * @param {string} value the bech32 address to decode
 */

var decodeAddress = function decodeAddress(value) {
  var decodeAddress = _bech["default"].decode(value);

  return Buffer.from(_bech["default"].fromWords(decodeAddress.words));
};
/**
 * Checks whether an address is valid.
 * @category crypto
 * @param {string} address the bech32 address to decode
 * @param {string} hrp the prefix to check for the bech32 address
 * @return {boolean}
 */


exports.decodeAddress = decodeAddress;

var checkAddress = function checkAddress(address, hrp) {
  try {
    if (!address.startsWith(hrp)) {
      return false;
    }

    var decodedAddress = _bech["default"].decode(address);

    var decodedAddressLength = decodeAddress(address).length;

    if (decodedAddressLength === DECODED_ADDRESS_LEN && decodedAddress.prefix === hrp) {
      return true;
    }

    return false;
  } catch (err) {
    return false;
  }
};
/**
 * Encodes an address from input data bytes.
 * @category crypto
 * @param {string} value the public key to encode
 * @param {*} prefix the address prefix
 * @param {*} type the output type (default: hex)
 */


exports.checkAddress = checkAddress;

var encodeAddress = function encodeAddress(value) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "tbnb";
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "hex";
  var words;

  if (Buffer.isBuffer(value)) {
    words = _bech["default"].toWords(Buffer.from(value));
  } else {
    words = _bech["default"].toWords(Buffer.from(value, type));
  }

  return _bech["default"].encode(prefix, words);
};
/**
 * Generates 32 bytes of random entropy
 * @category crypto
 * @param {number} len output length (default: 32 bytes)
 * @returns {string} entropy bytes hexstring
 */


exports.encodeAddress = encodeAddress;

var generatePrivateKey = function generatePrivateKey() {
  var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PRIVKEY_LEN;
  return (0, _utils.ab2hexstring)((0, _secureRandom["default"])(len));
};
/**
 * Generates an arrayBuffer filled with random bits.
 * @category crypto
 * @param {number} length - Length of buffer.
 * @returns {ArrayBuffer}
 */


exports.generatePrivateKey = generatePrivateKey;

var generateRandomArray = function generateRandomArray(length) {
  return (0, _secureRandom["default"])(length);
};
/**
 * @category crypto
 * @param {string} publicKey - Encoded public key
 * @return {Elliptic.PublicKey} public key hexstring
 */


exports.generateRandomArray = generateRandomArray;

var getPublicKey = function getPublicKey(publicKey) {
  var keyPair = ec.keyFromPublic(publicKey, "hex");
  return keyPair.getPublic();
};
/**
 * Calculates the public key from a given private key.
 * @category crypto
 * @param {string} privateKeyHex the private key hexstring
 * @return {string} public key hexstring
 */


exports.getPublicKey = getPublicKey;

var getPublicKeyFromPrivateKey = function getPublicKeyFromPrivateKey(privateKeyHex) {
  if (!privateKeyHex || privateKeyHex.length !== PRIVKEY_LEN * 2) {
    throw new Error("invalid privateKey");
  }

  var curve = new _elliptic.ec(CURVE);
  var keypair = curve.keyFromPrivate(privateKeyHex, "hex");
  var unencodedPubKey = keypair.getPublic().encode("hex", false);
  return unencodedPubKey;
};
/**
 * PubKey performs the point-scalar multiplication from the privKey on the
 * generator point to get the pubkey.
 * @category crypto
 * @param {Buffer} privateKey
 * @return {Elliptic.PublicKey} PubKey
 * */


exports.getPublicKeyFromPrivateKey = getPublicKeyFromPrivateKey;

var generatePubKey = function generatePubKey(privateKey) {
  var curve = new _elliptic.ec(CURVE);
  var keypair = curve.keyFromPrivate(privateKey);
  return keypair.getPublic();
};
/**
 * Gets an address from a public key hex.
 * @category crypto
 * @param {string} publicKeyHex the public key hexstring
 * @param {string} prefix the address prefix
 */


exports.generatePubKey = generatePubKey;

var getAddressFromPublicKey = function getAddressFromPublicKey(publicKeyHex, prefix) {
  var pubKey = ec.keyFromPublic(publicKeyHex, "hex");
  var pubPoint = pubKey.getPublic();
  var compressed = pubPoint.encodeCompressed();
  var hexed = (0, _utils.ab2hexstring)(compressed);
  var hash = (0, _utils.sha256ripemd160)(hexed); // https://git.io/fAn8N

  var address = encodeAddress(hash, prefix);
  return address;
};
/**
 * Gets an address from a private key.
 * @category crypto
 * @param {string} privateKeyHex the private key hexstring
 * @param {string} prefix the address prefix
 */


exports.getAddressFromPublicKey = getAddressFromPublicKey;

var getAddressFromPrivateKey = function getAddressFromPrivateKey(privateKeyHex, prefix) {
  return getAddressFromPublicKey(getPublicKeyFromPrivateKey(privateKeyHex), prefix);
};
/**
 * Generates a signature (64 byte <r,s>) for a transaction based on given private key.
 * @category crypto
 * @param {string} signBytesHex - Unsigned transaction sign bytes hexstring.
 * @param {string | Buffer} privateKey - The private key.
 * @return {Buffer} Signature. Does not include tx.
 */


exports.getAddressFromPrivateKey = getAddressFromPrivateKey;

var generateSignature = function generateSignature(signBytesHex, privateKey) {
  var msgHash = (0, _utils.sha256)(signBytesHex);
  var msgHashHex = Buffer.from(msgHash, "hex");

  var signature = _tinySecp256k["default"].sign(msgHashHex, typeof privateKey === "string" ? Buffer.from(privateKey, "hex") : privateKey);

  return signature;
};
/**
 * Verifies a signature (64 byte <r,s>) given the sign bytes and public key.
 * @category crypto
 * @param {string} sigHex - The signature hexstring.
 * @param {string} signBytesHex - Unsigned transaction sign bytes hexstring.
 * @param {string} publicKeyHex - The public key.
 * @return {boolean}
 */


exports.generateSignature = generateSignature;

var verifySignature = function verifySignature(sigHex, signBytesHex, publicKeyHex) {
  var publicKey = Buffer.from(publicKeyHex, "hex");
  if (!_tinySecp256k["default"].isPoint(publicKey)) throw new Error("Invalid public key provided");
  var msgHash = (0, _utils.sha256)(signBytesHex);
  var msgHashHex = Buffer.from(msgHash, "hex");
  return _tinySecp256k["default"].verify(msgHashHex, publicKey, Buffer.from(sigHex, "hex"));
};
/**
 * Generates a keystore object (web3 secret storage format) given a private key to store and a password.
 * @category crypto
 * @param {string} privateKeyHex the private key hexstring.
 * @param {string} password the password.
 * @return {object} the keystore object.
 */


exports.verifySignature = verifySignature;

var generateKeyStore = function generateKeyStore(privateKeyHex, password) {
  var salt = _cryptoBrowserify["default"].randomBytes(32);

  var iv = _cryptoBrowserify["default"].randomBytes(16);

  var cipherAlg = "aes-256-ctr";
  var kdf = "pbkdf2";
  var kdfparams = {
    dklen: 32,
    salt: salt.toString("hex"),
    c: 262144,
    prf: "hmac-sha256"
  };

  var derivedKey = _cryptoBrowserify["default"].pbkdf2Sync(Buffer.from(password), salt, kdfparams.c, kdfparams.dklen, "sha256");

  var cipher = _cryptoBrowserify["default"].createCipheriv(cipherAlg, derivedKey.slice(0, 32), iv);

  if (!cipher) {
    throw new Error("Unsupported cipher");
  }

  var ciphertext = Buffer.concat([cipher.update(Buffer.from(privateKeyHex, "hex")), cipher["final"]()]);
  var bufferValue = Buffer.concat([derivedKey.slice(16, 32), ciphertext]);
  return {
    version: 1,
    id: _uuid["default"].v4({
      random: _cryptoBrowserify["default"].randomBytes(16)
    }),
    crypto: {
      ciphertext: ciphertext.toString("hex"),
      cipherparams: {
        iv: iv.toString("hex")
      },
      cipher: cipherAlg,
      kdf: kdf,
      kdfparams: kdfparams,
      // mac must use sha3 according to web3 secret storage spec
      mac: (0, _utils.sha3)(bufferValue.toString("hex"))
    }
  };
};
/**
 * Gets a private key from a keystore given its password.
 * @category crypto
 * @param {string} keystore the keystore in json format
 * @param {string} password the password.
 */


exports.generateKeyStore = generateKeyStore;

var getPrivateKeyFromKeyStore = function getPrivateKeyFromKeyStore(keystore, password) {
  if (!_is_js["default"].string(password)) {
    throw new Error("No password given.");
  }

  var json = _is_js["default"].object(keystore) ? keystore : JSON.parse(keystore);
  var kdfparams = json.crypto.kdfparams;

  if (kdfparams.prf !== "hmac-sha256") {
    throw new Error("Unsupported parameters to PBKDF2");
  }

  var derivedKey = _cryptoBrowserify["default"].pbkdf2Sync(Buffer.from(password), Buffer.from(kdfparams.salt, "hex"), kdfparams.c, kdfparams.dklen, "sha256");

  var ciphertext = Buffer.from(json.crypto.ciphertext, "hex");
  var bufferValue = Buffer.concat([derivedKey.slice(16, 32), ciphertext]); // try sha3 (new / ethereum keystore) mac first

  var mac = (0, _utils.sha3)(bufferValue.toString("hex"));

  if (mac !== json.crypto.mac) {
    // the legacy (sha256) mac is next to be checked. pre-testnet keystores used a sha256 digest for the mac.
    // the sha256 mac was not compatible with ethereum keystores, so it was changed to sha3 for mainnet.
    var macLegacy = (0, _utils.sha256)(bufferValue.toString("hex"));

    if (macLegacy !== json.crypto.mac) {
      throw new Error("Keystore mac check failed (sha3 & sha256) - wrong password?");
    }
  }

  var decipher = _cryptoBrowserify["default"].createDecipheriv(json.crypto.cipher, derivedKey.slice(0, 32), Buffer.from(json.crypto.cipherparams.iv, "hex"));

  var privateKey = Buffer.concat([decipher.update(ciphertext), decipher["final"]()]).toString("hex");
  return privateKey;
};
/**
 * Generates mnemonic phrase words using random entropy.
 * @category crypto
 */


exports.getPrivateKeyFromKeyStore = getPrivateKeyFromKeyStore;

var generateMnemonic = function generateMnemonic() {
  return bip39.generateMnemonic(MNEMONIC_LEN);
};
/**
 * Validates mnemonic phrase words.
 * @ignore
 * @param {string} mnemonic the mnemonic phrase words
 * @return {bool} validation result
 */


exports.generateMnemonic = generateMnemonic;
var validateMnemonic = bip39.validateMnemonic;
/**
 * Get a private key from mnemonic words.
 * @category crypto
 * @param {string} mnemonic the mnemonic phrase words
 * @param {Boolean} derive derive a private key using the default HD path (default: true)
 * @param {number} index the bip44 address index (default: 0)
 * @param {string} password according to bip39
 * @return {string} hexstring
 */

exports.validateMnemonic = validateMnemonic;

var getPrivateKeyFromMnemonic = function getPrivateKeyFromMnemonic(mnemonic) {
  var derive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var password = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";

  if (!bip39.validateMnemonic(mnemonic, bip39.wordlists.english) && !bip39.validateMnemonic(mnemonic, bip39.wordlists.chinese_simplified) && !bip39.validateMnemonic(mnemonic, bip39.wordlists.chinese_traditional) && !bip39.validateMnemonic(mnemonic, bip39.wordlists.korean) && !bip39.validateMnemonic(mnemonic, bip39.wordlists.french) && !bip39.validateMnemonic(mnemonic, bip39.wordlists.italian) && !bip39.validateMnemonic(mnemonic, bip39.wordlists.spanish) && !bip39.validateMnemonic(mnemonic, bip39.wordlists.japanese)) {
    throw new Error("wrong mnemonic format");
  }

  var seed = bip39.mnemonicToSeedSync(mnemonic, password);

  if (derive) {
    var master = bip32.fromSeed(seed);
    var child = master.derivePath(HDPATH + index);

    if (!child.privateKey) {
      throw new Error("child does not have a privateKey");
    }

    return child.privateKey.toString("hex");
  }

  return seed.toString("hex");
};

exports.getPrivateKeyFromMnemonic = getPrivateKeyFromMnemonic;